import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SuperuserRoutingModule } from './superuser-routing.module';
import { SuperuserServiceModule } from './superuser-service.module';
import { TenantsComponent } from './components/views/tenants/tenants.component';
import { TenantDetailsComponent } from './components/views/tenant-form/tenant-details.component';
import { ModalWindowComponent } from './components/common/modal-window/modal-window';
import { DashboardComponent } from './components/views/dashboard/dashboard.component';
import { DynamicFormQuestionComponent } from './components/common/dynamic-form-question.component/dynamic-form-question.component';
import { GeneralListComponent } from './components/general/list/generalList.component';
import { GeneralFormComponent } from './components/general/form/generalForm.component';
import { GroupListComponent } from './components/views/groups/group-list.component';
import { GroupFormComponent } from './components/views/groupForm/group-form.component';
import { UserRightListComponent } from './components/views/userright-list/userRight-list.component';
import { UserRightFormComponent } from './components/views/userright-form/userRight-form.component';
import { UserRightGroupListComponent } from './components/views/userrightgroup-list/userRightGroup-list.component';
import { UserRightGroupFormComponent } from './components/views/userrightgroup-form/userRightGroup-form.component';
import { RightsOfGroupComponent } from './components/common/rights-of-group/rights-of-group.component';
import { GroupsOfRightComponent } from './components/common/groups-of-right/groups-of-right.component';
import { UserListComponent } from './components/views/users/user-list.component';
import { UserFormComponent } from './components/views/user-form/user-form.component';
import { GroupsSelectionComponent } from './components/common/groups-selections/groups-selection';
import { ButtonsComponent } from './components/common/buttons/buttons.component';
import { ArrayComponent } from './components/common/array/array.component';
import { ToolsComponent } from './components/views/tools/tools.component';
import { RightsSelectionComponent } from './components/common/rights-selections/rights-selection';
import { AdditionalRightListComponent } from './components/views/additionalright-list/additionalRight-list.component';
import { AdditionalRightFormComponent } from './components/views/additionalright-form/additionalRight-form.component';
import { AutomationMappingFormComponent } from './components/views/automatiomapping-form/automationMapping-form.component';
import { AutomationMappingListComponent } from './components/views/automationmapping-list/automationMapping-list.component';
import { RegoVivoMappingFormComponent } from './components/views/regovivomapping-form/regoVivoMapping-form.component';
import { RegoVivoMappingListComponent } from './components/views/regovivomapping-list/regoVivoMapping-list.component';
import { AboutComponent } from './components/views/about/about.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularWebStorageModule } from 'angular-web-storage';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import { QmDirectivesModule } from '../components/qm-directives/qm-directives.module';
import { SuperuserComponent } from './components/application/superuser.component';
import { MessagesComponent } from './components/common/messages/messages.component';
import { DynamicFormComponent } from './components/common/dynamic-form.component/dynamic-form.component';
import { SuperuserPermissionGuard } from './superuser-permission-guard.service';

@NgModule({
  declarations: [
    SuperuserComponent,
    TenantsComponent,
    TenantDetailsComponent,
    ModalWindowComponent,
    DashboardComponent,
    DynamicFormComponent,
    DynamicFormQuestionComponent,
    GeneralListComponent,
    GeneralFormComponent,
    GroupListComponent,
    GroupFormComponent,
    UserRightListComponent,
    UserRightFormComponent,
    UserRightGroupListComponent,
    UserRightGroupFormComponent,
    RightsOfGroupComponent,
    GroupsOfRightComponent,
    UserListComponent,
    UserFormComponent,
    GroupsSelectionComponent,
    ButtonsComponent,
    MessagesComponent,
    ArrayComponent,
    ToolsComponent,
    RightsSelectionComponent,
    AdditionalRightListComponent,
    AdditionalRightFormComponent,
    AutomationMappingFormComponent,
    AutomationMappingListComponent,
    RegoVivoMappingFormComponent,
    RegoVivoMappingListComponent,
    AboutComponent,
  ],
  providers: [
    SuperuserPermissionGuard
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    ReactiveFormsModule,
    AngularWebStorageModule,
    FontAwesomeModule,
    QmDirectivesModule,
    SuperuserRoutingModule,
    SuperuserServiceModule
  ]
})
export class SuperuserModule { }
